export default "__VITE_ASSET__d86c6a46__"